import AdaptiveContainer from '@onepercentio/one-ui/components/AdaptiveContainer'
import AsyncWrapper from '@onepercentio/one-ui/components/AsyncWrapper'
import Button from '@onepercentio/one-ui/components/Button'
import Loader from '@onepercentio/one-ui/components/Loader'
import Spacing from '@onepercentio/one-ui/components/Spacing'
import useAsyncControl from '@onepercentio/one-ui/hooks/useAsyncControl'
import { LPTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import Container from 'openspace/components/Container'
import Text from 'openspace/components/Text'
import React, { Fragment, PropsWithChildren } from 'react'
import { t } from 'translate/i18n'

/**
 * Receives a control and protect child until data is available
 **/
export default function AsyncControl({
  control,
  children,
  ...actions
}: PropsWithChildren<{ control: ReturnType<typeof useAsyncControl<any>> }> &
  ClickActions<'onClose' | 'onRetry'>) {
  const content = (() => {
    if (control.error)
      return (
        <Fragment key={'load'}>
          <Text code='generic.errorMsg' type={LPTypo.P1Bold} />
          <Spacing size='32'/>
          <Button onClick={actions.onRetry} variant='filled'>
            {t('generic.retryBtn')}
          </Button>
          <Spacing size='8'/>
          <Button onClick={actions.onClose}>{t('generic.goBack')}</Button>
        </Fragment>
      )
    if (control.loading) return <Loader key={'error'} />
    return <Fragment key={'empty'} />
  })()
  return (
    <>
      {children}
      <Container center textCenter>
        <AdaptiveContainer direction='v'>{content}</AdaptiveContainer>
      </Container>
    </>
  )
}
